import React, { useEffect, useState } from "react";
import ApiService from "../../service/ApiService";
import { apiPaths } from "../../service/apiPaths";
import Slider from "react-slick";
import img1 from "../../assets/images/home/1.png";   
import img2 from "../../assets/images/home/2.png";   
import img3 from "../../assets/images/home/3.png";   
import img4 from "../../assets/images/home/4.png";   

const BannerSlider = () => {
  const [banners, setBanners] = useState([]);
  const [dotActive, setDotActive] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchBanners = async () => {
      setLoading(true);
      try {
        const response = await ApiService({
          method: "GET",
          endpoint: apiPaths.getBanner,
        });

        if (response.success && Array.isArray(response.data)) {
          setBanners(response.data);
        } else {
          console.error("Invalid response format", response);
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (prev, next) => {
      setDotActive(next);
    },
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "7%",
          transform: "translateY(-50%)",
        }}
      >
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={
          i === dotActive
            ? {
                width: "30px",
                color: "#262626",
                borderRight: "3px #262626 solid",
                padding: "8px 0",
                cursor: "pointer",
              }
            : {
                width: "30px",
                color: "transparent",
                borderRight: "3px white solid",
                padding: "8px 0",
                cursor: "pointer",
              }
        }
      >
        0{i + 1}
      </div>
    ),
  };

  // if (banners.length === 0) {
  //   return <div>Loading banners...</div>;
  // }

  return (
    // <div className="w-full bg-white">
    //   <Slider {...settings}>
    //     {
    //       loading ? (
    //         <div
    //           className="h-full w-full skeleton banner-skeleton"
    //         >
    //         </div>
    //       ) :
    //         (banners.length !== 0 ? (
    //           banners.map((bannerUrl, index) => (
    //             <div key={index}>
    //               <img
    //                 className="h-full w-full"
    //                 alt={`Banner ${index + 1}`}
    //                 src={bannerUrl}
    //               />
    //             </div>
    //           ))
    //         ) : (
    //           <p>Not banner</p>
    //         )
    //         )
    //     }
    //   </Slider>
    // </div>

    <div className="w-full bg-white">
      <Slider {...settings}>
        <div>
          <img
            className="w-full h-auto object-cover"
            src={img1}
            alt="Skybags Banner 1"
          />
        </div>
        <div>
          <img
            className="w-full h-auto object-cover"
            src={img2}
            alt="Skybags Banner 2"
          />
        </div>
        <div>
          <img
            className="w-full h-auto object-cover"
            src={img3}
            alt="Skybags Banner 2"
          />
        </div>
        <div>
          <img
            className="w-full h-auto object-cover"
            src={img4}
            alt="Skybags Banner 2"
          />
        </div>
      </Slider>
    </div>
  );
};

export default BannerSlider;
